import React from 'react';
import { styled } from '../../../../theme';
import { CardManagementFormWidget } from '../widgets/billing/CardManagementFormWidget';

export interface SelectCardDetailsWidgetProps {
  onNext: () => any;
  onCancel: () => any;
  org_id: string;
  card?: string;
  cardSelected: (card: string) => any;
  legalUrl?: string;
}

export const SelectCardDetailsWidget: React.FC<SelectCardDetailsWidgetProps> = (props) => {
  return (
    <CardManagementFormWidget
      legalUrl={props.legalUrl}
      back={{
        label: 'Back',
        action: () => {
          props.onCancel();
        }
      }}
      next={{
        label: 'Next',
        disabled: !props.card,
        action: () => {
          props.onNext();
        }
      }}
      org_id={props.org_id}
      desc="Select or add a card for this subscription."
      cardAdded={(config_id) => {
        props.cardSelected(config_id);
      }}
      generateCard={(card, element) => {
        const _selected = card.model.id === props.card;
        return (
          <S.Card
            onClick={() => {
              props.cardSelected(card.model.id);
            }}
          >
            {React.cloneElement(element, { selected: _selected })}
            <S.CardSelected selected={_selected}>Selected</S.CardSelected>
          </S.Card>
        );
      }}
    />
  );
};

namespace S {
  export const Card = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
  `;

  export const CardSelected = styled.div<{ selected: boolean }>`
    opacity: ${(p) => (p.selected ? 1 : 0)};
    font-size: 14px;
    margin-top: 10px;
    color: ${(p) => p.theme.text.primary};
  `;
}
